<template>
      <div class="studentRequirementEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'studentRequirement', params: {} }">
          Student Requirement
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'studentRequirementEdit', params:{id: id} }">
            Edit Student Requirement
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Student Requirement</v-card-title>
          <v-card-text>
            <studentRequirement-form :id="id"></studentRequirement-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import StudentRequirementForm from './StudentRequirementForm.vue';

    export default {
      name: 'studentRequirement',
      data () {
        return {
          id: null
        }
      },
      components: {
        StudentRequirementForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    